import type { CookieSetOptions } from 'universal-cookie';
import Cookies from 'universal-cookie';
import { CONFIG } from '@frameio/config';
import { isServer, isTest } from '../config/helpers';

const cookies: Cookies = new Cookies();

/**
 * Get the cookie settings that should be used when setting auth cookies
 *
 * @environments client
 */
function getCookieParams(options: CookieSetOptions = {}): CookieSetOptions {
  // Don't scope cookies in tests, because then they can't be read.
  if (isTest()) return {};

  return {
    path: '/',
    sameSite: 'lax',
    domain: CONFIG.cookieDomain,
    ...options,
  };
}

export function getCookie(key: string) {
  if (isServer) {
    // eslint-disable-next-line no-console
    console.warn('Tried to read cookies during server rendering.');
    return undefined;
  }

  return cookies.get(key);
}

export function setCookie(
  key: string,
  value?: string,
  options: CookieSetOptions = {}
): void {
  if (isServer) {
    return;
  }

  if (options.domain !== window.location.hostname) {
    removeCookie(key, { domain: window.location.hostname });
  }

  cookies.set(key, value, getCookieParams(options));
}

export function removeCookie(
  key: string,
  options: CookieSetOptions = {},
  /** Removes all cookies with this name, regardless of options */
  omitOptions = false
): void {
  if (isServer) {
    return;
  }

  cookies.remove(key, omitOptions ? undefined : getCookieParams(options));
}

export const testExports = {
  getCookieParams,
};
